import PropTypes from "prop-types";
import { useState } from "react";
import { useSelector } from "react-redux";
import { Popper, Card, ClickAwayListener, Chip, Box, Autocomplete, TextField, Tooltip } from "@mui/material";
import { CustomAvatarGroup, CustomAvatar } from "../custom-avatar";

ChatBoxUsers.propTypes = {
  users: PropTypes.array,
  deleteUser: PropTypes.func,
  addUser: PropTypes.func,
  allUsers: PropTypes.array
}

export default function ChatBoxUsers({ users, deleteUser, addUser, allUsers  }) {

  const { user } = useSelector((state) => state.user);
  const { data: { invoiceItemData : { invoice } } } = useSelector((state) => state.invoicing);
  
  const [isUsersMenuOpen, setIsUsersMenuOpen] = useState(false);

  const [anchorEl, setAnchorEl] = useState(null);

  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
    setIsUsersMenuOpen(true);
  };

  const handleClose = () => {
    setIsUsersMenuOpen(false);
    setAnchorEl(null);
  };

  const UsersList = () => <Box>
    <ClickAwayListener onClickAway={handleClose}>
      <Card
        sx={{
          p: 1,
          mt: 1,
          ml: 1,
          bgcolor: 'white',
          maxWidth: '200px',
        }}>
        {users.map(u => <Chip
          disabled={!invoice || (invoice?.editingLocked && u.addedBy !== user.id)}
          key={u.email}
          label={u.fullName}
          sx={{ m: '1px', fontSize: '12px' }}
          onDelete={() => { deleteUser(u?.id, u?.email) }}
          avatar={
            <CustomAvatar
              name={u?.fullName || u?.email}
              email={u?.email}
              sx={{ '&.MuiChip-avatar': { color: '#fff !important', } }}
            />}
        />
        )}
        <Box sx={{ width: '100%', mr: 1, mt: 1 }}>
          {' '}
          <Autocomplete
            size="small"
            multiple
            sx={{minWidth: '150px'} }
            id="tags-outlined"
            options={allUsers || []}
            getOptionLabel={(option) => `${option.value} - ${option.email}`}
            value={users}
            onChange={(event, newValue, l) => {
              const added = newValue.find((item) => !users.includes(item));
              const addedEmail = typeof added === 'string' ? added : added?.email ?? null;  
              if(added) addUser(added?.id, addedEmail);
            }}
            freeSolo
            disableClearable
            filterSelectedOptions
            renderTags={() => null}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Type email"
                placeholder="Add user"
                autoComplete="off"
              />
            )}
            renderOption={(props, option) => (
              <li {...props}>
                <Box
                  sx={{
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    maxWidth: '280px',
                  }}
                >
                  {option.value} - {option.email}
                </Box>
              </li>
            )}
            PopperComponent={(props) => (
              <Popper {...props} style={{ maxWidth: '300px' }} placement="bottom-start" />
            )}
          />
        </Box>
      </Card>
    </ClickAwayListener>
  </Box>

  return (
    <Box>
      <CustomAvatarGroup
        size="small"
        sx={{
          justifyContent: 'left',
        }}
      >
        {users?.slice(0, 2).map((user, index) => (
          <CustomAvatar name={user?.fullName || user?.email} email={user?.email} key={index} />
        ))}
        {users?.length > 2 && <Tooltip arrow
          placement="top"
          title={
            <>
              {users?.slice(2).map((user, index) => (
                <div key={index}>
                  <div>{user?.fullName} {user?.email}</div>
                </div>
              ))}
            </>
          }
        >
          <CustomAvatar
            name={'+'}
            showTooltip={false}
            sx={{
              cursor: 'pointer',
              fontSize: '10px !important',
            }}
            children={`${users?.length - 2}`}
          />
        </Tooltip>}
        <Tooltip title="Add user">
          <CustomAvatar
            name={'+'}
            showTooltip={false}
            onClick={handleOpen}
            sx={{
              cursor: 'pointer',
              backgroundColor: 'primary.main',
              width: '12px !important',
              height: '12px !important',
              my: 'auto',
              marginLeft: '-4px !important',
              zIndex: 1,
            }}
          />
        </Tooltip>
      </CustomAvatarGroup>
      <Popper open={isUsersMenuOpen} anchorEl={anchorEl} sx={{ zIndex: 1000 }}>
        <UsersList />
      </Popper>
    </Box>
  )
}